import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="eco-grid-dark bg-navyDeep text-center text-white" aria-label="Limited time offer" data-id="element-267" data-mp="369pga49jt16e">
      <div className="h-1.5 w-full bg-solar" aria-hidden="true" data-id="element-268" data-mp="31ipjr04ccl4f" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-269" data-mp="31h4rjh5i1e9q">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-solar" data-id="element-270" data-mp="3g72ig4utci2m">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-271" data-mp="3b8iuy00kmy85" /> Launch pricing ends in
        </p>
        <Countdown className="mt-5" data-id="element-272" data-mp="3p8a5trvsjyhx" />
        <p className="mt-7 font-bold text-white/80" data-id="element-273" data-mp="3l78d7twdqkox">After that the price increases and never drops again.</p>

        <div className="mx-auto mt-6 max-w-xl rounded-lg bg-white/10 p-4 text-sm" data-id="element-274" data-mp="1uuiv0p1q78kw">
          <p className="font-bold text-white" data-id="element-275" data-mp="1qt74mhb12jbn">
            <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-solar" data-id="element-276" data-mp="1quik3edu5fil" />
            Remaining launch pricing spots: limited
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-white/15" data-id="element-277" data-mp="2xshn1lvc2uem">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '66%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full rounded-full bg-solar" data-id="element-278" data-mp="2xqemw90gvkw6" />
          </div>
          <p className="mt-1 text-right text-xs text-white/70" data-id="element-279" data-mp="3cjzyd6d900rn">66% of spots taken</p>
        </div>
      </div>
      <div className="h-1.5 w-full bg-leaf" aria-hidden="true" data-id="element-280" data-mp="3libxxxw3e8w8" />
    </section>;
}